import '../league.css';

import { useLeague } from '../../../hooks';
import { Header, Spin } from '../../../components';

const LeagueContent = () => {
  const { league, asyncLeague, currentSeason, loading } = useLeague();

  return (
    <div>
      <Header
        league={{
          icon: league?.icon,
          name: `Liga ${league?.name}`,
        }}
      />

      {!asyncLeague || !league || !currentSeason || loading ? (
        <div className="league-page-loading-container">
          <Spin />
        </div>
      ) : (
        <>
          {asyncLeague?.enabled ? (
            <>{league?.page && <league.page />}</>
          ) : (
            <div className="league-disabled-container">
              <h2 className="league-disabled-title">
                La Liga <b>{league?.name}</b> aún no está disponible...
              </h2>
              <h3 className="league-disabled-legend">
                Pronto la inauguraremos
              </h3>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LeagueContent;
